import React from "react";
import {
  Modal,
  ModalHeader,
  ModalProps,
} from "@sonder/ui/source/styled/components/Modal";
import { ModalFooter } from "@sonder/ui/source/styled/fragments/Modal";
import { PrimaryButton } from "@sonder/ui/source/styled/fragments/PrimaryButton";
import { useUpdateTask } from "core/queries/UpdateTask";
import { TaskStatus } from "typings/globalGQLTypes";

interface ArchiveTaskModal extends Omit<ModalProps, "children"> {
  taskId: string;
}

export const ArchiveTaskModal = ({
  isOpen,
  onClose,
  taskId,
}: ArchiveTaskModal) => {
  const [onUpdateTask, { loading: isUpdating }] = useUpdateTask({
    onCompleted: () => {
      if (onClose) onClose();
    },
    refetchQueries: [
      // Top Level Metrics for /schedule
      "GetSchedulerMetrics",
      // List of Cleans for /schedule
      "GetTaskSchedules",
      // List of Tasks for /tasks
      "GetTasks",
      // Task Details Panel
      "GetTask",
    ],
  });
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      {({ closeModal }) => (
        <>
          <ModalHeader title="Delete Clean" onClose={closeModal} />
          <p>Are you sure?</p>
          <p>
            This will completely remove this clean from the board. You will{" "}
            <b>not</b> be able to schedule it again for today.
          </p>
          <p>
            <b>Note: This cannot be undone!</b>
          </p>
          <ModalFooter>
            <PrimaryButton
              disabled={isUpdating || !taskId}
              onClick={() => {
                if (taskId)
                  onUpdateTask({
                    variables: {
                      status: TaskStatus.canceled,
                      taskId,
                    },
                  });
              }}
            >
              I&apos;m sure
            </PrimaryButton>
          </ModalFooter>
        </>
      )}
    </Modal>
  );
};
